import React, { ReactElement } from 'react';
import {
  Link, Table, Tbody, Td, Th, Thead, Tr, Text,
} from 'idsk-react-components';
import PublikovanyTerminListPage from '../../../model/PublikovanyTerminListPage';
import routes from '../../../routing/routes';

interface Props {
  terminPage: PublikovanyTerminListPage | null | undefined;
  isSelectedFilter: boolean;
}

const PublikovanyTerminTable = ({
  terminPage,
  isSelectedFilter,
}: Props): ReactElement => {
  if (terminPage.totalElements === 0 && isSelectedFilter) {
    return (
      <Text type="p" size="l" className="text-center">Nenašli sa žiadne termíny zodpovedajúce zvolenému filtru.</Text>
    );
  }

  if (terminPage.totalElements === 0) {
    return <Text type="p" size="l" className="text-center">Neexistujú žiadne termíny.</Text>;
  }

  if (terminPage.totalElements > 0 && terminPage.terminList.length === 0) {
    return (
      <Text type="p" size="l" className="text-center">
        Na aktuálnej stránke sa nenachádzajú žiadne termíny.
      </Text>
    );
  }

  return (
    <Table className="publikovany-termin-list-table">
      <Thead>
        <Tr>
          <Th>Termín</Th>
          <Th>Preferovaný termín</Th>
          <Th>Tezaurus</Th>
        </Tr>
      </Thead>
      <Tbody>
        {terminPage.terminList.map((termin) => (
          <Tr key={termin.uuid}>
            <Td>
              <Link to={routes.tezaurus.detail.withParams(termin.termin === termin.preferovanyTermin
                ? termin.uuid
                : termin.terminUuid)}
              >{termin.termin}
              </Link>
            </Td>
            <Td>{termin.preferovanyTermin}</Td>
            <Td>{termin.tezaurus}</Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  );
};

export default PublikovanyTerminTable;
